import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get palika
export const getPalika = createAsyncThunk("palika/getPalika", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getPalika({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all palika
export const getAllPalika = createAsyncThunk("palika/getAllPalika", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllPalika();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("palika/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("palika/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("palika/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPagePalika({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create palika
export const createPalika = createAsyncThunk("palika/createPalika", async (param, { rejectWithValue }) => {
  const { name, postalCode, district, locationId, isActive, isDeliverable } = param;
  try {
    const body = JSON.stringify({ name, postalCode, district, locationId, isActive, isDeliverable });
    const { data } = await API.createPalika(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updatePalika = createAsyncThunk("palika/updatePalika", async (param, { rejectWithValue }) => {
  const { id, values } = param;
  const { name, postalCode, district, locationId, isActive, isDeliverable } = values;
  try {
    const body = JSON.stringify({ name, postalCode, district, locationId, isActive, isDeliverable });
    const { data } = await API.updatePalika(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("palika/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
